import useAsync from "@hooks/useAsync";
import NoticeServices from "@services/NoticeServices";
import React from "react";
import style from "./notice.module.css";
import { AiFillBell } from "react-icons/ai";

export default function NavbarNotice() {
  const { data, loading } = useAsync(NoticeServices.getShowingNotice);

  return (
    <div className="bg-green-600 text-white py-1 w-full">
      <div className="ntc m-auto flex justify-center">
      <div className="flex items-center px-3 text-2xl lg:text-lg hidden"><AiFillBell /></div>
          {loading ? (
            <div
            className="px-1 opacity-0">
            <svg className="animate-spin h-6 w-5 mr-3" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            />
          </svg>
          </div>
          ) : (
            <marquee scrollamount="4" ><div
              className="px-1"
              dangerouslySetInnerHTML={{ __html: data[0]?.text }}
            ></div></marquee>
          )}
    
      </div>
    </div>
  );
}
